<template>
    <div>
        <div :id="reactContainerId"></div>
    </div>
</template>

<script>
import { mountReactComponent, unmountReactComponent } from "../../../../utility/mountReactComponent";
import APWizard from "../../../react-view/APWizard";

export default {
    name: "CreateAPReactWrapper",
    props: {
        wizardStep: {
            type: String,
        },
        changePage: {
            type: Function,
        },
        closeWizardModal: {
            type: Function,
        },
        wizardNotification: {
            type: Function,
        },
        createAccessPointWizard: {
            type: Function,
        },
        selectedACU: {
            type: Object,
        },

    },
    data() {
        return {
            reactContainerId: `react-container-05RB055`,
        };
    },
    methods: {
        handleChangePage(page) {
            this.$emit('changePage', page);
        },
        handleCloseModal() {
            this.$emit('closeWizardModal');
        },
        handleNotification(notification) {
            this.$emit('wizardNotification', notification);
        },
        handleSaveAccessPoint(data) {
            this.$emit('createAccessPointWizard', data);
        },

        mountReactWizardComponent() {
            mountReactComponent(
                APWizard,
                {
                    handleNotification: this.handleNotification,
                    handleCloseModal: this.handleCloseModal,
                    wizardStep: this.wizardStep,
                    closeACUModal: () => { },
                    changeWizardPage: this.handleChangePage,
                    selectedACU: this.selectedACU,
                    saveAccessPoint: this.handleSaveAccessPoint,
                },
                this.reactContainerId
            );
        },
        unmountReactWizardComponent() {
            unmountReactComponent(this.reactContainerId); // Clean up the React component
        },
    },
    mounted() {
        this.mountReactWizardComponent();
        // if (this.acuModels) {

        // }
    },
    beforeDestroy() {
        this.unmountReactWizardComponent();
    },
    watch: {
        acuModels: {
            deep: true, // Watches for deep changes in the object
            handler() {
                this.unmountReactWizardComponent(); // Clean up the previous React component
                this.mountReactWizardComponent(); // Mount with updated data
            },
        },
        wizardStep: { // Watch for changes in the wizardStep prop
            handler() {
                this.unmountReactWizardComponent(); // Clean up the previous React component
                this.mountReactWizardComponent(); // Mount with updated data
            },
            immediate: true, // Optionally trigger immediately on component initialization
        },
    },
};
</script>
